import React, { useMemo } from "react";
import AsyncSelect from "react-select/async";
import instance from "../../Interceptor/api_instance";
import debounce from "lodash.debounce";
import { customStyles } from "../Utility/ReactSelectStyles";
import { useTranslation } from "react-i18next";

const MechanicSearch = ({ onSelect, selectedOption, required=true}) => {
  const {t} = useTranslation();
  const filterOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 1) return [];

    try {
      const res = await instance.get(`safety/get-employees?title=mechanic&name=${inputValue}`);
      return res.data.map((option) => ({
        value: option.id,
        label: option.full_name,
      }));
    } catch (err) {
      console.error("Failed to fetch list: ", err);
      return [];
    }
  };

  // ✅ Debounce filterOptions and return a wrapped function that resolves a Promise
  const debouncedLoadOptions = useMemo(() => {
    const wrapped = debounce((inputValue, callback) => {
      filterOptions(inputValue).then(callback);
    }, 1000); // 500ms debounce

    return (inputValue) =>
      new Promise((resolve) => wrapped(inputValue, resolve));
  }, []);

  return (
    <AsyncSelect
      cacheOptions
      aria-label="Mechanic"
      inputId="mechanic-select"
      name="mechanic"
      defaultOptions={false}
      loadingMessage={() => t("general.loading")}
      loadOptions={debouncedLoadOptions}
      onChange={(option) => onSelect(option)}
      placeholder={t("forms.type.vehicle.search.visitor.search")}
      noOptionsMessage={() => t("forms.type.vehicle.search.visitor.not-found")}
      isClearable
      className="search-select"
      styles={customStyles}
      unstyled={true}
      value={selectedOption}
      required={required}
    />
  );
};

export default React.memo(MechanicSearch);